import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import { TemplateService } from 'src/app/shared/services/template.service';

interface Lang {
  label: string;
  value: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  loading: boolean = false;
  currentUser: any;
  notificationCount: number = 0;
  cancellationCount: number = 0;

  constructor(
    private templateService: TemplateService,
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private router: Router
  ) {}

  get isCompanyUser(): boolean {
    return this.currentUser?.role === 'company';
  }

  get showCancellationsNav(): boolean {
    return this.loading && this.isCompanyUser;
  }

  ngOnInit() {
    this.getCurrentUser();
    this.getNotificationCount();
    this.getCancellationCount();
  }

  getNotificationCount() {
    this.afAuth.authState.subscribe((user) => {
      if (user) {
        this.afs
          .collection('company-notifications', (ref) =>
            ref.where('receiverId', '==', user.uid).where('seen', '==', false)
          )
          .valueChanges()
          .subscribe((notifications: any[]) => {
            this.notificationCount = notifications.length;
          });
      }
    });
  }

  getCancellationCount() {
    this.afAuth.authState.subscribe((user) => {
      if (!user) {
        return;
      }

      this.afs
        .collection('users')
        .doc(user.uid)
        .valueChanges()
        .subscribe((profile: any) => {
          if (profile?.role !== 'company') {
            this.cancellationCount = 0;
            return;
          }

          this.afs
            .collection('cancellationWarning', (ref) =>
              ref.where('receiverId', '==', user.uid).where('seen', '==', false)
            )
            .valueChanges()
            .subscribe((warnings: any[]) => {
              this.cancellationCount = warnings.length;
            });
        });
    });
  }

  getCurrentUser() {
    this.afAuth.authState.subscribe((user) => {
      if (user) {
        this.afs.collection('users').doc(user.uid).valueChanges().subscribe((user) => {
          this.currentUser = user;
          this.loading = true;
          console.log(this.currentUser);
        })
      } else {
        this.loading = false;
      }
    });
  }

  collapseSidebar() {
    this.templateService.collapsed = !this.templateService.collapsed;
    this.templateService.setMessage('Collapse Sidebar');
  }

  logout() {
    this.afAuth.signOut();
    this.router.navigateByUrl('/login');
  }
}
